import { render, staticRenderFns } from "./BankForm.vue?vue&type=template&id=18ff7d2e&scoped=true&lang=html&"
import script from "./BankForm.vue?vue&type=script&lang=js&"
export * from "./BankForm.vue?vue&type=script&lang=js&"
import style0 from "./BankForm.vue?vue&type=style&index=0&id=18ff7d2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ff7d2e",
  null
  
)

export default component.exports